import api from "./api";

export const getAllAlertContacts = async (schemaName = null) => {
  try {
    const response = await api.get("/alert-contacts/", {
      params: schemaName ? { client: schemaName } : {},
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching alert contacts:", error);
    throw error;
  }
};

export const getAlertContactById = async (id, schemaName = null) => {
  try {
    const response = await api.get(`/alert-contacts/${id}/`, {
      params: schemaName ? { client: schemaName } : {},
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching alert contact:", error);
    throw error;
  }
};

export const createAlertContact = async (data, schemaName = null) => {
  try {
    const response = await api.post("/alert-contacts/", data, {
      params: schemaName ? { client: schemaName } : {},
    });
    return response.data;
  } catch (error) {
    console.error("Error creating alert contact:", error);
    throw error;
  }
};

export const updateAlertContact = async (id, data, schemaName = null) => {
  try {
    const response = await api.patch(`/alert-contacts/${id}/`, data, {
      params: schemaName ? { client: schemaName } : {},
    });
    return response.data;
  } catch (error) {
    console.error("Error updating alert contact:", error);
    throw error;
  }
};

export const deleteAlertContact = async (id, schemaName = null) => {
  try {
    const response = await api.delete(`/alert-contacts/${id}/`, {
      params: schemaName ? { client: schemaName } : {},
    });
    return response.data;
  } catch (error) {
    console.error("Error deleting alert contact:", error);
    throw error;
  }
};

export const refreshAlertGroups = async (schemaName = null) => {
  try {
    const response = await api.post("/alert-groups/refresh/", null, {
      params: schemaName ? { client: schemaName } : {},
    });
    return response.data;
  } catch (error) {
    console.error("Error refreshing alert groups:", error);
    throw error;
  }
};

export const getAllAlertGroups = async (schemaName = null) => {
  try {
    const response = await api.get("/alert-groups/", {
      params: schemaName ? { client: schemaName } : {},
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching alert groups:", error);
    throw error;
  }
};
